import React, { Fragment, useEffect, useState } from "react";
import Header from "../../Components/Layout/Header";
import {
  Backdrop,
  Box,
  Container,
  createTheme,
  CssBaseline,
  FormControl,
  Grid,
  ImageList,
  ImageListItem,
  InputLabel,
  MenuItem,
  Select,
  styled,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
import styles from "./InStoreFraming.module.css";
import banner1 from "../../Assets/instore-framing/Inside-framing-Section.webp";
import banner2 from "../../Assets/instore-framing/Glass-displaying.webp";
import banner3 from "../../Assets/instore-framing/Hanging-Image.webp";
import studio from "../../Assets/instore-framing/Social Icons/At-Studio.png";
import laptop from "../../Assets/instore-framing/Social Icons/Upload-from-PC.png";
import boxFramingServices from "../../Assets/instore-framing/Services Icon/Box-Framing-Services.jpg";
import businessCardPrintingServices from "../../Assets/instore-framing/Services Icon/Business-Card-Printing-Services.jpg";
import canvasPrintingServices from "../../Assets/instore-framing/Services Icon/Canvas-Printing-Services.jpg";
import canvasStretchingServices from "../../Assets/instore-framing/Services Icon/Canvas-Stretching-Services.jpg";
import classicFramingServices from "../../Assets/instore-framing/Services Icon/Classic-Framing-Services.jpg";
import deliveryServices from "../../Assets/instore-framing/Services Icon/Delivery-Services.jpg";
import floatingBoxFramingServices from "../../Assets/instore-framing/Services Icon/Floating-Box-Framing-Services.jpg";
import gicleePrintingServices from "../../Assets/instore-framing/Services Icon/Giclee-Printing--Services.jpg";
import glazingServices from "../../Assets/instore-framing/Services Icon/Glazing-Services.jpg";
import hangingServices from "../../Assets/instore-framing/Services Icon/Hanging-Services.jpg";
import memorabiliaFramingServices from "../../Assets/instore-framing/Services Icon/Memorabilia-Framing-Services.jpg";
import mirrorsServices from "../../Assets/instore-framing/Services Icon/Mirrors-Services.jpg";
import oilPaintingCleaningRestorationServices from "../../Assets/instore-framing/Services Icon/Oil-Painting-Cleaning-&-Restoration-Services.jpg";
import packagingServices from "../../Assets/instore-framing/Services Icon/Packaging-Services.jpg";
import photoEditingServices from "../../Assets/instore-framing/Services Icon/Photo-Editing-Services.jpg";
import posterPrintingServices from "../../Assets/instore-framing/Services Icon/Poster-Printing-Services.jpg";
import sweptFramingServices from "../../Assets/instore-framing/Services Icon/Swept-Framing-Services.jpg";
import trayorBoxFramingServices from "../../Assets/instore-framing/Services Icon/Tray-or-Box-Framing-Services.jpg";
import satisfaction from "../../Assets/Satisfaction Garanteed.png";
import delivery from "../../Assets/Delivery.png";
import customer from "../../Assets/Customer Service.png";
import trusted from "../../Assets/Trusted by expert.png";
import glassSample from "../../Assets/instore-framing/Glass-Sample-in-box.webp";
import glassType from "../../Assets/instore-framing/Glass-Types.jpg";
import hangingStyle from "../../Assets/instore-framing/Hanging-Styles.jpg";
import parkingMap from "../../Assets/instore-framing/Parking Map.webp";
import { Link } from "react-router-dom";
import Parse from "../../API/ParseServer";
import Album from "../../Components/Album/Album";
import Footer from "../../Components/Layout/Footer";
import { motion } from "motion/react";
import frames from "../../Assets/instore-framing/frames.webp";
const defaultTheme = createTheme();
const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#737373",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#863a18",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#863a18",
    },
    "&:hover fieldset": {
      borderColor: "#863a18",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#863a18",
    },
  },
});
const CustomeSelect = styled(Select)(({ theme }) => ({
  color: "black",
  borderColor: "#863a18",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#863a18 !important",
  },
}));
const CustomeLabel = styled(InputLabel)(({ theme }) => ({
  // color: "black",
  zIndex: 10000,
  width: "10rem",
  borderColor: "#863a18",
  backgroundColor: "white",

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#863a18 !important",
  },
  "&.Mui-focused": {
    color: "#863a18",
  },
}));
const InStoreFraming = () => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log({
      email: data.get("email"),
      password: data.get("password"),
    });
  };
  const [modal, setModal] = React.useState("");
  const handleClose = () => {
    setModal("");
  };
  const handleOpen = (event: any) => {
    setModal(event.target.id);
  };
  const [album, setAlbum] = useState<any>();
  const [albumArray, setAlbumArray] = useState<number[]>([]);

  useEffect(() => {
    const fetchAlbum = async () => {
      const query = new Parse.Query("Album");

      try {
        const results = await query.find();
        // setTopics(results);
        results.forEach((album: any) => {
          if (album.get("type") === "InStore") {
            setAlbum(album);
            console.log(album.get("counter"));
            for (let i = 1; i <= album.get("counter"); i++) {
              setAlbumArray((cur: number[]) => {
                if (!cur.find((num: any) => num === i)) return [...cur, i];
                else return cur;
              });
            }
          }
        });
        // console.log(results);
      } catch (err: any) {
        // setErrorMessage(err.message);
      } finally {
        // setLoading(false);
      }
    };

    fetchAlbum();
  }, []);
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [details, setDetails] = useState("");
  const [service, setService] = React.useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const validEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const validMobile =
    /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
  const formSubmitHandler = async (event: any) => {
    event.preventDefault();

    if (!(email && name && mobile && details && service))
      setErrorMessage("Please fill in your information completely");
    else if (!validEmail.test(String(email)))
      setErrorMessage("Email address format is invalid.");
    else if (!validMobile.test(String(mobile)))
      setErrorMessage("Mobile format is invalid.");
    else {
      setLoading(true);
      setErrorMessage("");

      try {
        // Create a new instance of the "Form" class
        const Form = Parse.Object.extend("Form");
        const form = new Form();

        // Set the form data
        form.set("type", "In-Store Framing - Get a Quote");
        form.set("userName", name);
        form.set("userEmail", email);
        form.set("userMobile", mobile);
        form.set("company", company);
        form.set("details", details);
        form.set("services", service);
        form.set("status", "new");

        // Save the form data to Parse Server
        await form.save();
        setName("");
        setCompany("");
        setEmail("");
        setMobile("");
        setDetails("");
        setService([]);
        setErrorMessage("Your information has been successfully submitted");
      } catch (error: any) {
        console.error("Error submitting form:", error);
        setErrorMessage(error.message);
      } finally {
        setLoading(false);
        // setModal("");
      }
    }
  };

  const nameChangeHandler = (event: any) => {
    setName(event.target.value);
  };
  const companyChangeHandler = (event: any) => {
    setCompany(event.target.value);
  };
  const emailChangeHandler = (event: any) => {
    setEmail(event.target.value);
  };
  const mobileChangeHandler = (event: any) => {
    setMobile(event.target.value);
  };
  const detailsChangeHandler = (event: any) => {
    setDetails(event.target.value);
  };
  const serviceChangeHandler = (event: any) => {
    setService(event.target.value);
  };
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 },
    },
  };
  const scaleVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: (custom: any) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 * custom },
    }),
  };
  return (
    <Fragment>
      <Container sx={{ pt: 6 }}>
        <Grid container>
          <Grid
            item
            xs={12}
            md={9}
            sx={{ textAlign: { xs: "center", sm: "start" } }}
          >
            <motion.div
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <Typography component="h2" variant="h3">
                Professional Framing
              </Typography>
              <Typography>
                <br />
                Proud to offer professional framing services since 1993. All our
                frames are bespoke and made by our experienced team of artisan
                framers. Offering free consultation for maximising the
                presentation and protection of your artwork. Our showroom
                features over 700 different types of frames in varying profiles
                and colours ranging from traditional to contemporary and modern
                designs.
                <br />
                <br /> We also offer online framing service which is great when
                you like to have express framing for your paintings, posters and
                more.
              </Typography>

              <button
                className={styles.button}
                onClick={() => {
                  const element = document.getElementById("services");
                  if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                View Services
              </button>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
      <img
        src={banner1}
        alt="Inside-framing-Section"
        className={styles.banner}
      />
      <Box sx={{ width: "100%", backgroundColor: "#fcfcfc" }}>
        <Container sx={{ mt: { xs: "70vw", sm: "60vw" }, pb: 6 }}>
          <Grid
            container
            sx={{
              justifyContent: "space-between",
              textAlign: { xs: "center", md: "start" },
            }}
            spacing={5}
          >
            <Grid item xs={12} md={2}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={studio}
                  alt="At-Studio"
                  style={{
                    width: "100%",
                    maxWidth: "15rem",
                  }}
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} md={3.8}>
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography component="h2" variant="h3">
                  In-Store Framing
                </Typography>
                <Typography>
                  <br />
                  Suitable for those seeking professional framing advice to
                  maximise the presentation and protection of their artwork.
                  <br />
                  <br />
                  Our showroom features over 700 frames in a variety of styles,
                  colours, and profiles, and during your visit, we will provide
                  you with personalised advice on appropriate framing styles for
                  your artworks, sports shirts, 3D objects and more
                </Typography>
                <button
                  className={styles.button}
                  onClick={() => {
                    const element = document.getElementById("Visit");
                    if (element) {
                      element.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                >
                  Visit Us
                </button>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={2}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={laptop}
                  alt="At-Studio"
                  style={{ width: "100%", maxWidth: "15rem" }}
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} md={3.8}>
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography component="h2" variant="h3">
                  Online Framing
                </Typography>
                <Typography>
                  <br />
                  A quick and simple way to order custom-made frames made by
                  professionals for posters, artwork, and more.
                  <br />
                  <br />
                  From the comfort of your own home, you can now view your
                  artworks in various different frames with varying profiles,
                  styles and colours. We will ship your custom-built frame along
                  with instructions for putting your art inside - a little fun
                  DIY!
                  <br />
                </Typography>
                <Link to={"/framing"}>
                  <button className={styles.button}>Start Framing</button>
                </Link>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* <img
        src={frames}
        alt="Inside-framing-Section"
        className={styles.banner}
      /> */}
      <img
        src={frames}
        alt="Glass-displaying"
        style={{ width: "100%", height: "50rem", objectFit: "cover" }}
      />

      {/* <Box
        sx={{ width: "100%", height: "30rem", backgroundColor: "gray" }}
      ></Box> */}
      <Box
        sx={{ width: "100%", backgroundColor: "#fcfcfc", pt: 7 }}
        id="services"
      >
        <Container sx={{ py: 8 }}>
          <motion.div
            variants={textVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <Typography component="h2" variant="h3">
              Services
            </Typography>
            <Typography>
              <br />
              We are proud to be able to offer a wide selection of customised
              frames, mounts and mirrors to meet the needs of all of our
              customers throughout London. In addition to the large range of
              customised frames available, we also supply an impressive
              selection of off-the- shelf picture and photo frames.
              <br />
              <br />
              One of the biggest range of frames is located at our Framing shop
              which comprise of the best quality mouldings with variety of
              colours and quality finishes. Our primary concern is to protect
              and present art work to the highest levels. We ensure high quality
              and appropriate framing solutions that meet our clients' needs.
              Whether it's a print or a drawing, a painting or a 3D object, a
              poster or textiles, we can find a custom made framing solution for
              you.
            </Typography>
          </motion.div>
          <Grid container spacing={2} sx={{ py: 3 }}>
            <Backdrop
              sx={(theme) => ({
                color: "#fff",
                zIndex: theme.zIndex.drawer + 1,
              })}
              open={modal === "" ? false : true}
              onClick={handleClose}
            >
              <img
                src={
                  modal === "classicFramingServices"
                    ? classicFramingServices
                    : modal === "boxFramingServices"
                      ? boxFramingServices
                      : modal === "floatingBoxFramingServices"
                        ? floatingBoxFramingServices
                        : modal === "trayorBoxFramingServices"
                          ? trayorBoxFramingServices
                          : modal === "memorabiliaFramingServices"
                            ? memorabiliaFramingServices
                            : modal === "sweptFramingServices"
                              ? sweptFramingServices
                              : modal === "canvasStretchingServices"
                                ? canvasStretchingServices
                                : modal === "glazingServices"
                                  ? glazingServices
                                  : modal === "mirrorsServices"
                                    ? mirrorsServices
                                    : modal === "packagingServices"
                                      ? packagingServices
                                      : modal === "gicleePrintingServices"
                                        ? gicleePrintingServices
                                        : modal === "canvasPrintingServices"
                                          ? canvasPrintingServices
                                          : modal === "posterPrintingServices"
                                            ? posterPrintingServices
                                            : modal === "photoEditingServices"
                                              ? photoEditingServices
                                              : modal ===
                                                  "oilPaintingCleaningRestorationServices"
                                                ? oilPaintingCleaningRestorationServices
                                                : modal ===
                                                    "businessCardPrintingServices"
                                                  ? businessCardPrintingServices
                                                  : modal === "deliveryServices"
                                                    ? deliveryServices
                                                    : modal ===
                                                        "hangingServices"
                                                      ? hangingServices
                                                      : ""
                }
                alt={modal}
                style={{ width: "95%", maxWidth: "30rem" }}
              />
            </Backdrop>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={classicFramingServices}
                  alt="classicFramingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="classicFramingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={2}
              >
                <img
                  src={boxFramingServices}
                  alt="boxFramingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="boxFramingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={3}
              >
                <img
                  src={floatingBoxFramingServices}
                  alt="floatingBoxFramingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="floatingBoxFramingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={4}
              >
                <img
                  src={trayorBoxFramingServices}
                  alt="trayorBoxFramingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="trayorBoxFramingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={memorabiliaFramingServices}
                  alt="memorabiliaFramingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="memorabiliaFramingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={2}
              >
                <img
                  src={sweptFramingServices}
                  alt="sweptFramingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="sweptFramingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={3}
              >
                <img
                  src={canvasStretchingServices}
                  alt="canvasStretchingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="canvasStretchingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={4}
              >
                <img
                  src={glazingServices}
                  alt="glazingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="glazingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={mirrorsServices}
                  alt="mirrorsServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="mirrorsServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={2}
              >
                <img
                  src={packagingServices}
                  alt="packagingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="packagingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={3}
              >
                <img
                  src={gicleePrintingServices}
                  alt="gicleePrintingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="gicleePrintingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={4}
              >
                <img
                  src={canvasPrintingServices}
                  alt="canvasPrintingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="canvasPrintingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={posterPrintingServices}
                  alt="posterPrintingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="posterPrintingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={2}
              >
                <img
                  src={photoEditingServices}
                  alt="photoEditingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="photoEditingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={3}
              >
                <img
                  src={oilPaintingCleaningRestorationServices}
                  alt="oilPaintingCleaningRestorationServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="oilPaintingCleaningRestorationServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={4}
              >
                <img
                  src={businessCardPrintingServices}
                  alt="businessCardPrintingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="businessCardPrintingServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={deliveryServices}
                  alt="deliveryServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="deliveryServices"
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={2}
              >
                <img
                  src={hangingServices}
                  alt="hangingServices"
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={handleOpen}
                  id="hangingServices"
                />
              </motion.div>
            </Grid>
          </Grid>
          <motion.div
            variants={textVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <Grid
              container
              sx={{ pb: 5, display: "flex", justifyContent: "space-between" }}
            >
              <Grid item xs={12} md={3.8} sx={{ mt: 3 }}>
                <Typography component="h2" variant="h3">
                  Get a quote
                </Typography>
                <Typography>
                  <br />
                  Fill out this form to get an idea of our framing prices. We
                  aim to respond to all enquiries within two business days.
                  <br />
                  <br />
                  All quotes obtained through this service are estimates; for
                  exact quotes, please visit our showroom.
                </Typography>
              </Grid>
              <Grid item container xs={12} md={8}>
                <ThemeProvider theme={defaultTheme}>
                  <CssBaseline />

                  <Grid container spacing={2} component="form" sx={{ mt: 3 }}>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: { xs: "13px", lg: "19px" },
                      }}
                    >
                      <CssTextField
                        required
                        fullWidth
                        id="fullName"
                        label="Full Name"
                        name="fullName"
                        onChange={nameChangeHandler}
                        value={name}
                      />
                      <CssTextField
                        fullWidth
                        id="company"
                        label="Company (If Applicable)"
                        name="company"
                        onChange={companyChangeHandler}
                        value={company}
                      />
                      <CssTextField
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        onChange={emailChangeHandler}
                        value={email}
                      />
                      <CssTextField
                        required
                        fullWidth
                        id="contactNumber"
                        label="Contact Number"
                        name="contactNumber"
                        onChange={mobileChangeHandler}
                        value={mobile}
                      />
                      {/* <FormControl fullWidth>
                        <CustomeLabel id="select-label">
                          Choose a service *
                        </CustomeLabel>
                        <CustomeSelect
                          labelId="select-label"
                          id="select"
                          label="Choose a service *"
                          fullWidth
                          required
                          multiple
                          onChange={serviceChangeHandler}
                          value={service}
                        >
                          <MenuItem value={"Classic Frame"}>
                            Classic Frame
                          </MenuItem>
                          <MenuItem value={"Box Frame"}>Box Frame</MenuItem>
                          <MenuItem value={"Floating Box Frame"}>
                            Floating Box Frame
                          </MenuItem>
                          <MenuItem value={"Europe"}>Europe</MenuItem>
                          <MenuItem value={"Europe"}>Europe</MenuItem>
                          <MenuItem value={"Europe"}>Europe</MenuItem>
                          <MenuItem value={"Europe"}>Europe</MenuItem>
                          <MenuItem value={"Europe"}>Europe</MenuItem>
                          <MenuItem value={"Europe"}>Europe</MenuItem>
                          <MenuItem value={"Europe"}>Europe</MenuItem>
                          <MenuItem value={"Europe"}>Europe</MenuItem>
                        </CustomeSelect>
                      </FormControl> */}
                      <FormControl fullWidth>
                        <InputLabel
                          id="demo-simple-select-label"
                          sx={{ color: "#737373 !important" }}
                        >
                          Choose a service *
                        </InputLabel>
                        <CustomeSelect
                          labelId="service-select-label"
                          id="service-select"
                          label="Choose a service *"
                          fullWidth
                          multiple
                          onChange={serviceChangeHandler}
                          value={service}
                        >
                          <MenuItem value={"Classic Frame"}>
                            Classic Frame
                          </MenuItem>
                          <MenuItem value={"Box Frame"}>Box Frame</MenuItem>
                          <MenuItem value={"Floating Box Frame"}>
                            Floating Box Frame
                          </MenuItem>
                          <MenuItem value={"Tray / Floater Frame"}>
                            Tray / Floater Frame
                          </MenuItem>
                          <MenuItem value={"Swept Frame"}>Swept Frame</MenuItem>
                          <MenuItem value={"Memorabilia Framing"}>
                            Memorabilia Framing
                          </MenuItem>
                          <MenuItem value={"Canvas Stretching"}>
                            Canvas Stretching
                          </MenuItem>
                          <MenuItem value={"Glazing"}>Glazing</MenuItem>
                          <MenuItem value={"Mirrors"}>Mirrors</MenuItem>
                          <MenuItem value={"Giclée Printing"}>
                            Giclée Printing
                          </MenuItem>
                          <MenuItem value={"Canvas Printing"}>
                            Canvas Printing
                          </MenuItem>
                          <MenuItem value={"Packaging"}>Packaging</MenuItem>
                          <MenuItem value={"Poster Printing"}>
                            Poster Printing
                          </MenuItem>
                          <MenuItem value={"Photo Editing & Restoration"}>
                            Photo Editing & Restoration
                          </MenuItem>
                          <MenuItem
                            value={"Oil Painting Cleaning & Restoration"}
                          >
                            Oil Painting Cleaning & Restoration
                          </MenuItem>
                          <MenuItem value={"Business Card Printing"}>
                            Business Card Printing
                          </MenuItem>
                          <MenuItem value={"Delivery"}>Delivery</MenuItem>
                          <MenuItem value={"Picture Hanging"}>
                            Picture Hanging
                          </MenuItem>
                        </CustomeSelect>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <CssTextField
                        required
                        fullWidth
                        name="description"
                        label="Description"
                        type="text"
                        id="description"
                        multiline
                        rows={14}
                        onChange={detailsChangeHandler}
                        value={details}
                      />
                    </Grid>
                  </Grid>

                  <button
                    className={styles.button}
                    style={{ margin: "1rem auto" }}
                    onClick={formSubmitHandler}
                  >
                    Submit
                  </button>
                  {errorMessage && (
                    <Typography sx={{ textAlign: "center", width: "100%" }}>
                      {errorMessage}
                    </Typography>
                  )}
                </ThemeProvider>
              </Grid>
            </Grid>
          </motion.div>
        </Container>
      </Box>
      <Box sx={{ width: "100%", backgroundColor: "#d9d9d9", pb: 7 }}>
        <Container sx={{ textAlign: "center" }}>
          <Grid container spacing={7}>
            <Grid item xs={12} sm={6} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={satisfaction}
                  alt="satisfaction"
                  className={styles.icons}
                />
                <Typography variant="subtitle1">
                  Satisfaction Guaranteed
                </Typography>
                <Typography variant="body2" sx={{ color: "#949494" }}>
                  100% guaranteed satisfaction. We go above and beyond to make
                  you happy with our service, and your satisfaction is our goal.
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={2}
              >
                <img src={delivery} alt="delivery" className={styles.icons} />
                <Typography variant="subtitle1">Consultation </Typography>
                <Typography variant="body2" sx={{ color: "#949494" }}>
                  Receive free framing consultation from experienced team of
                  artisan framers
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={3}
              >
                <img src={customer} alt="customer" className={styles.icons} />
                <Typography variant="subtitle1">
                  Great Customer Service
                </Typography>
                <Typography variant="body2" sx={{ color: "#949494" }}>
                  Constantly improving our services to make it easier for you to
                  have a more enjoyable experience coing our services
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={4}
              >
                <img src={trusted} alt="trusted" className={styles.icons} />
                <Typography variant="subtitle1">
                  Trusted by Professionals
                </Typography>
                <Typography variant="body2" sx={{ color: "#949494" }}>
                  Working with the bests in the field of art and framing has
                  made us an attractive choice for collectors, auctioneers and
                  art enthusiasts
                </Typography>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <img src={banner2} alt="Glass-displaying" style={{ width: "100%" }} />
      <Box sx={{ width: "100%", backgroundColor: "#fafafa" }}>
        <Container sx={{ pt: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography component="h2" variant="h4">
                  Glass & Acrylic Options
                </Typography>
                <Typography>
                  <br />
                  View our extensive selection of glass and Acrylic glazing
                  options. Apart from the standard float glass which is one of
                  the widely used glass in picture framing, we also offer art
                  specialised glass and acrylic that offer protection from UV
                  damage and also antireflection properties.
                  <br />
                  <br />
                  UV glass are ideal for original arts and limited edition
                  prints. Anti Reflect Glass is ideal for deep frames and boxes
                  where low reflectance for clarity of the image is critical.
                  Please get in touch for further information and advise.
                </Typography>
                <img
                  src={glassSample}
                  alt="glass sample"
                  style={{ width: "100%" }}
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} md={8}>
              <img src={glassType} alt="glass-type" style={{ width: "100%" }} />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <img src={banner3} alt="Hanging" style={{ width: "100%" }} />
      <Box sx={{ width: "100%", backgroundColor: "#FAFAFA" }}>
        <Container sx={{ py: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography component="h2" variant="h4">
                  Fixings & Haging
                </Typography>
                <Typography>
                  <br />
                  At Faam, we offer various types of hangings suitable for a
                  different size, style and type of frame. From traditional D
                  ring to modern hangers that enable more flushes hanging
                  finish.
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={8}>
              <img
                src={hangingStyle}
                alt="hanging-style"
                style={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Container>
        <motion.div
          variants={textVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 3,
            }}
          >
            <Typography component="h2" variant="h4">
              Our Album
            </Typography>
          </Box>
          <Typography>
            <br />
            Browse through our previous works for unique framing ideas,
            inspiration and gift ideas.
            <br /> Follow us on Instagram, Facebook and Twitter.
          </Typography>
        </motion.div>
        <Box sx={{ width: "100%" }}>
          {album && <Album album={album} albumArray={albumArray} />}
        </Box>
      </Container>
      <br id="Visit" />
      <br />
      <br />
      <br />
      <br />
      <Box sx={{ width: "100%", backgroundColor: "#fcfcfc", pb: 30, pt: 5 }}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={6}>
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography
                  component="h2"
                  variant="h3"
                  sx={{ textAlign: "center" }}
                >
                  Visit our showroom
                </Typography>
                <Typography>
                  <br />
                  For the best experience, visit our showroom to view our
                  collection of 700+ frames.
                  <br /> Don't forget to bring your artworks!
                  <br />
                  <br />
                  If you wish to book an appointment click here!
                  <br />
                  <br />
                </Typography>
                <Typography variant="h6">Address:</Typography>
                <Typography>
                  131 Percy Road, Whitton, Twickenham, London, TW2 6HT
                  <br /> Mon to Fri: 9:30am to 5:30pm | Sat: 10:30am to 5:30pm |
                  Sun: Closed
                  <br /> <br />
                </Typography>
                <Typography sx={{ textDecoration: "underline" }}>
                  Tel: 020 3632 1468
                  <br /> Email: framing@faamgallery.com <br />
                  <br />
                </Typography>
                <Typography variant="h6">Parking:</Typography>
                <Typography>
                  Free street parking after 2pm on Jubilee Ave and Montrose Ave
                  <br /> (except during event days)
                  <br /> <br />
                  Paid parking bays on Jubilee Ave (3 spaces) and Montrose Ave
                  (3 spaces) <br /> 30min: 65p | 60min: £1.25 | 90min: £1.85
                  <br />
                  <br />
                </Typography>
                <Typography variant="h6">Public Transport:</Typography>
                <Typography>
                  Bus: Whitton Station Stop (H22 & 110) - 1 min walk
                  <br />
                  Train station: Whitton Railway station 1 min walk
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={6}>
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <img
                  src={parkingMap}
                  alt="parking-map"
                  style={{ width: "100%" }}
                />
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Fragment>
  );
};

export default InStoreFraming;
